import { useEffect, useState } from "react";
import ValidIcon from "../../assets/icons/emergency_home.svg";
import "./CustomInput.css";

const CustomInput = ({
  editable = false,
  value = "",
  placeholder = "",
  styles = {},
  isPassword = false,
  validationStr,
  isRequired = false,
  onChange,
  readOnly = false,
  preview = true,
  label,
  isError = false,
  isTextArea = false,
  rows = 3,
  errorlabel = "",
  onSelect = () => {},
  additionalValText = "",
}) => {
  const [validationError, setValidationError] = useState();
  useEffect(() => {
    if (value) {
      if (validationStr && validationStr.test(value)) {
        setValidationError(false);
      } else {
        setValidationError(true);
      }
    }
  }, [value]);

  return readOnly ? (
    <div className="flex flex-col form-detail">
      <div className="emp-form-label">{label}</div>
      <div className="emp-form-input">{value}</div>
    </div>
  ) : preview || isRequired ? (
    <div className="flex flex-col form-detail">
      {label && (
        <div className="emp-form-label">
          {label}
          {isRequired && "*"}
        </div>
      )}
      {isTextArea ? (
        <textarea
          className={`emp-form-textarea ${
            validationError ||
            (isError && !value && !validationError && isRequired)
              ? "error-border"
              : ""
          }`}
          rows={rows}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          disabled={!editable}
          style={styles}
          placeholder={placeholder}
          onSelect={(e) => onSelect(e.target.value)}
        />
      ) : (
        <input
          onChange={(e) => onChange(e.target.value)}
          value={value}
          className={`emp-form-input ${
            validationError ||
            (isError && !value && !validationError && isRequired)
              ? "error-border"
              : ""
          }`}
          disabled={!editable}
          placeholder={placeholder}
          style={styles}
          type={isPassword ? "password" : "text"}
          onSelect={(e) => onSelect(e.target.value)}
        />
      )}
      {additionalValText && isError && !value ? (
        <div className="valid-text flex items-center">
          <img src={ValidIcon} alt="" style={{ marginRight: "4px" }} />
          <div className="valid-text">{additionalValText}</div>
        </div>
      ) : isError && !value && !validationError && isRequired ? (
        <div className="valid-text flex items-center">
          <img src={ValidIcon} alt="" style={{ marginRight: "4px" }} />
          <div>Enter your {errorlabel ? errorlabel : label}</div>
        </div>
      ) : null}
      {validationError && !additionalValText && (
        <div className="valid-text flex items-center">
          <img src={ValidIcon} alt="" style={{ marginRight: "4px" }} />
          <div className="valid-text">
            Enter valid {errorlabel ? errorlabel : label}
          </div>
        </div>
      )}
    </div>
  ) : (
    <></>
  );
};
export default CustomInput;
